import React from 'react'
import { 
    amber,
    blue,
    blueGrey,
    brown,
    common,
    cyan,
    deepOrange,
    deepPurple,
    green,
    grey,
    indigo,
    lightBlue,
    lightGreen,
    lime,
    orange,
    pink,
    purple,
    red,
    teal,
    yellow
} from '@mui/material/colors';

import { Avatar as MuiAvatar } from '@mui/material';

const COLORS = [
    amber,
    blue,
    blueGrey,
    brown,
    common,
    cyan,
    deepOrange,
    deepPurple,
    green,
    grey,
    indigo,
    lightBlue,
    lightGreen,
    lime,
    orange,
    pink,
    purple,
    red,
    teal,
    yellow
]

export function randomColor() {
    return COLORS[Math.floor(Math.random()*COLORS.length)]
}

export default function Avatar({name, src, bgColor}) {
  let firstLetter = name.charAt(0).toUpperCase()
  let color = bgColor ? bgColor : randomColor()
  return (
    <MuiAvatar
      sx={{ bgcolor: color[500] }}
      src={src}
    >
        {!src ? firstLetter : null}
    </MuiAvatar>
  )
}
